import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class BrickWall extends DestroyableObstacle {
	static key = "BrickWall";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.CONCRETE_DEBRIS;
	}

	static deserialize(data: any): BrickWall {
		const b = new BrickWall(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
